export default "__VITE_ASSET__r0$6pTcb__"